import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IfspHeartBeatType {
  referralId: string | null;
  userId: string | null;
  reportEmpId: string | null;
  reportEmpName: string | null;
  dailyRoutineEmpId: string | null;
  dailyRoutineEmpName: string | null;
  familyConcernsEmpId: string | null;
  familyConcernsEmpName: string | null;
  developmentalSummaryEmpId: string | null;
  developmentalSummaryEmpName: string | null;
  healthEligibilityEmpId: string | null;
  healthEligibilityEmpName: string | null;
  serviceDeliveryEmpId: string | null;
  serviceDeliveryEmpName: string | null;
  outcomeEmpId: string | null;
  outcomeEmpName: string | null;
  transitionEmpId: string | null;
  transitionEmpName: string | null;
  code: string | null;
  errorMessage: string | null;
}

export const initialState: IfspHeartBeatType = {
  referralId: null,
  userId: null,
  reportEmpId: null,
  reportEmpName: null,
  dailyRoutineEmpId: null,
  dailyRoutineEmpName: null,
  familyConcernsEmpId: null,
  familyConcernsEmpName: null,
  developmentalSummaryEmpId: null,
  developmentalSummaryEmpName: null,
  healthEligibilityEmpId: null,
  healthEligibilityEmpName: null,
  serviceDeliveryEmpId: null,
  serviceDeliveryEmpName: null,
  outcomeEmpId: null,
  outcomeEmpName: null,
  transitionEmpId: null,
  transitionEmpName: null,
  code: null,
  errorMessage: null,
};

const ifspHeartBeatSlice = createSlice({
  name: 'ifspHeartBeat',
  initialState,
  reducers: {
    setIfspHeartBeat: (state, action: PayloadAction<IfspHeartBeatType>) => {
      return action.payload;
    },
    updateIfspHeartBeat: (
      state,
      action: PayloadAction<Partial<IfspHeartBeatType>>,
    ) => {
      return { ...state, ...action.payload };
    },
    resetIfspHeatBeat: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('RESET_REDUX_APP_STATES', () => initialState);
  },
});

export const { setIfspHeartBeat, updateIfspHeartBeat, resetIfspHeatBeat } =
  ifspHeartBeatSlice.actions;
export default ifspHeartBeatSlice.reducer;
